import { format, parseISO, toDate, compareAsc, compareDesc } from 'date-fns';
export interface CampaignResponse {
	campaignId: number;
	startDate: Date;
	endDate: Date;
	campaignName: '';
}

export interface AdvertisementResponse {
	adId: number;
	startDate: Date;
	endDate: Date;
	name: string;
}
export interface ViewershipResult {
	dateArray: Array<any>;
	actualViewershipArray: Array<number>;
	potentialViewershipArray: Array<number>;
}

export const getReportForViewership = (json: any): ViewershipResult => {
	const viewershipData: ViewershipResult = {} as ViewershipResult;
	viewershipData.dateArray = [];
	viewershipData.actualViewershipArray = [];
	viewershipData.potentialViewershipArray = [];
	const resp = json;
	let arr = [];
	arr = json.map((ele: any) => {
		const newObject = { ...ele };
		newObject.date = toDate(parseISO(ele.date));
		return newObject;
	});
	arr = arr.sort(function (a: any, b: any) {
		return compareDesc(a.date, b.date);
	});
	arr.forEach((data: any) => {
		viewershipData.dateArray.push(format(data.date, 'dd/MM'));
		viewershipData.actualViewershipArray.push(data.actualViewershipCount);
		viewershipData.potentialViewershipArray.push(data.potentialViewershipCount);
	});
	return viewershipData;
};

export const campaignResponseSummation = (result: Array<any>) => {
	const sumRow: any = {
		CPI: '',
		Impressions: 0,
		LocationName: '',
		MainLocationId: '',
		TotalScreens: 0,
		Viewership: 0,
		summation: true,
	};
	result.forEach((row: any) => {
		sumRow.Impressions = sumRow.Impressions + parseInt(row.Impressions);
		sumRow.TotalScreens = sumRow.TotalScreens + parseInt(row.TotalScreens);
		sumRow.Viewership = sumRow.Viewership + parseInt(row.Viewership);
	});
	sumRow.Impressions = `Total Impressions -  ${sumRow.Impressions}`;
	sumRow.TotalScreens = `Total Screens -  ${sumRow.TotalScreens}`;
	sumRow.Viewership = `Total Viewership - ${sumRow.Viewership}`;
	return sumRow;
};
